import { useContext } from "react";
import { PageHeaderContext } from "@/layout/pageHeaderContext";

export function usePageHeader() {
  const ctx = useContext(PageHeaderContext);
  if (!ctx) throw new Error("usePageHeader must be used within PageHeaderProvider");
  return ctx;
}
